
import { connect } from 'react-redux';
import { getBase } from '../../../modules/Settings';
import { getMetadata } from '../../../modules/Filters';
import PaginationComponent from './Pagination';

const mapStateToProps = state => {
  return {
    metadata: getMetadata(state),
    base: getBase(state)
  };
};

const PaginationContainer = connect(mapStateToProps)(PaginationComponent);

export default PaginationContainer;
